/* eslint-disable camelcase */
import request from '@/utils/request'

// AIM analytics (BigQuery-backed, super_admin only).
// Backend: /api/v2/admin/analytics/aim/* (request baseURL already includes /api/v2).

export interface AimSummary {
  ozet: {
    gun_kayit: number
    toplam_oturum: number
    toplam_okuma: number
    cihaz: number
    kullanici: number
    ilk_gun: string
    son_gun: string
  }
  aylik: Array<{ ay: string, oturum: number, okuma: number, cihaz: number, kullanici: number }>
}

export interface AimDailyRow { gun: string, oturum: number, okuma: number, cihaz: number, kullanici: number }
export interface AimTopCaneRow { cane_id: string, oturum: number, okuma: number, aktif_gun: number, son_gun: string }

export const getAimSummary = () =>
  request({ url: '/admin/analytics/aim/summary', method: 'get' })

export const getAimDaily = (days = 30) =>
  request({ url: '/admin/analytics/aim/daily', method: 'get', params: { days } })

export const getAimTopCanes = (limit = 20) =>
  request({ url: '/admin/analytics/aim/top-canes', method: 'get', params: { limit } })
